import axios from 'axios';

export const settings = {
    namespaced: true,

    state: {
        tooltipData: {},
        cookieTermsAccepted: false,
        companyKey: null
    },

    actions: {
        loadTooltips ({ commit }) {
            axios.get('api/tooltips').then(function (response) {
                let toolTipSettingData = response.data.data.settings;
                commit('setToolTipData', toolTipSettingData);
            });
        }
    },

    mutations: {
        setToolTipData(state, tooltipData) {
            let newData = {};
            tooltipData.forEach(function (data) {
                newData[data.name] = data.value;
            })
            state.tooltipData = newData;
        },

        setCookieTermsAccepted(state, cookieTermsAccepted) {
            state.cookieTermsAccepted = cookieTermsAccepted;
        },

        setCompanyKey(state, key) {
            state.companyKey = key;
        }
    },

    getters: {
        getTooltipText: (state) => (name) => {
            return state.tooltipData[name];
        },
        showCookieBanner: state => ! state.cookieTermsAccepted,
    }
}
